import {all, call, put, takeLatest} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_admin_user';

function* fetchList({payload}) {
    try {
        const response = yield call(api.adminFetchUserList, payload.search, payload.offset, payload.limit, payload.sortBy);
        yield put(actions.adminUserListSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.adminUserListFailure(error));
    }
}

function* create(action) {
    try {
        const response = yield call(api.adminCreateUser, action.payload.data);
        yield put(actions.adminUserSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.adminUserFailure(error));
    }
}

function* edit(action) {
    try {
        const response = yield call(api.adminEditUser, action.payload.id, action.payload.data);
        yield put(actions.adminUserSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.adminUserFailure(error));
    }
}

function* fetch(action) {
    try {
        const response = yield call(api.adminFetchUser, action.payload.id);
        yield put(actions.adminUserSuccess(response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.adminUserFailure(error));
    }
}

export default function* root() {
    yield all([
        takeLatest(constants.ADMIN_USER_CREATE_REQUESTED, create),
        takeLatest(constants.ADMIN_USER_EDIT_REQUESTED, edit),
        takeLatest(constants.ADMIN_USER_LIST_REQUESTED, fetchList),
        takeLatest(constants.ADMIN_USER_REQUESTED, fetch),
    ]);
}
